import { configurationSelectors, settingsSelectors, State, TabDisplayInterface } from '@wam/shared';
import { combineLatest, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { Injectable, inject } from '@angular/core';
import { isStaff } from '@app/authentication/user.data';
import { RosteringService } from '@app/teacher-users/rostering-data.service';

@Injectable({
  providedIn: 'root',
})
export class AssessmentsTabDisplayService implements TabDisplayInterface {
  private store = inject<Store<State>>(Store);
  private readonly rosteringService = inject<RosteringService>(RosteringService);

  isFirst(): Observable<boolean> {
    return of<boolean>(false);
  }

  shouldShow(): Observable<boolean> {
    return combineLatest([
      this.store.pipe(select(settingsSelectors.getUserType)),
      this.store.pipe(select(configurationSelectors.getCourseConfiguration)),
      this.rosteringService.applyEIRRestrictions(),
    ]).pipe(
      map(
        ([userType, courseConfiguration, applyRestrictions]) =>
          courseConfiguration.ayla && !applyRestrictions && isStaff(userType),
      ),
    );
  }
}
